// extracted by mini-css-extract-plugin
export default {"overlay":"ProductModal_overlay__3vclE","modal":"ProductModal_modal__HYnoR","form":"ProductModal_form__dX3-A","actions":"ProductModal_actions__qeqcg"};